// 24 free Google Fonts exposed by the 3D Studio text customizer.
// `familia` MUST match the CSS font-family token exactly so the canvas
// `ctx.font` assignment picks up the loaded webfont.

export const TIPOGRAFIAS = [
  // ── DISPLAY ────────────────────────────────────────────
  { id: "bebas",      nombre: "Bebas Neue",          familia: "Bebas Neue",         categoria: "display",  preview: "REBEL"   },
  { id: "blackops",   nombre: "Black Ops One",       familia: "Black Ops One",      categoria: "display",  preview: "REBEL"   },
  { id: "russo",      nombre: "Russo One",           familia: "Russo One",          categoria: "display",  preview: "REBEL"   },
  { id: "orbitron",   nombre: "Orbitron",            familia: "Orbitron",           categoria: "display",  preview: "REBEL"   },
  { id: "bungee",     nombre: "Bungee",              familia: "Bungee",             categoria: "display",  preview: "REBEL"   },
  { id: "monoton",    nombre: "Monoton",             familia: "Monoton",            categoria: "display",  preview: "REBEL"   },

  // ── BOLD / POTENTE ─────────────────────────────────────
  { id: "anton",      nombre: "Anton",               familia: "Anton",              categoria: "bold",     preview: "REBEL"   },
  { id: "archivo",    nombre: "Archivo Black",       familia: "Archivo Black",      categoria: "bold",     preview: "REBEL"   },
  { id: "righteous",  nombre: "Righteous",           familia: "Righteous",          categoria: "bold",     preview: "Rebel"   },
  { id: "bangers",    nombre: "Bangers",             familia: "Bangers",            categoria: "bold",     preview: "Rebel!"  },
  { id: "rubik",      nombre: "Rubik Dirt",          familia: "Rubik Dirt",         categoria: "bold",     preview: "Rebel"   },

  // ── ELEGANTE ───────────────────────────────────────────
  { id: "cinzel",     nombre: "Cinzel",              familia: "Cinzel",             categoria: "elegante", preview: "REBEL"   },
  { id: "playfair",   nombre: "Playfair Display",    familia: "Playfair Display",   categoria: "elegante", preview: "Rebel"   },
  { id: "cormorant",  nombre: "Cormorant Garamond",  familia: "Cormorant Garamond", categoria: "elegante", preview: "Rebel"   },

  // ── SCRIPT / CURSIVA ───────────────────────────────────
  { id: "pacifico",   nombre: "Pacifico",            familia: "Pacifico",           categoria: "script",   preview: "Rebel"   },
  { id: "dancing",    nombre: "Dancing Script",      familia: "Dancing Script",     categoria: "script",   preview: "Rebel"   },
  { id: "greatvibes", nombre: "Great Vibes",         familia: "Great Vibes",        categoria: "script",   preview: "Rebel"   },
  { id: "sacramento", nombre: "Sacramento",          familia: "Sacramento",         categoria: "script",   preview: "Rebel"   },

  // ── STREET / URBAN ─────────────────────────────────────
  { id: "marker",     nombre: "Permanent Marker",    familia: "Permanent Marker",   categoria: "street",   preview: "Rebel"   },
  { id: "creepster",  nombre: "Creepster",           familia: "Creepster",          categoria: "street",   preview: "Rebel"   },
  { id: "special",    nombre: "Special Elite",       familia: "Special Elite",      categoria: "street",   preview: "Rebel"   },

  // ── TECH / MONO ────────────────────────────────────────
  { id: "press",      nombre: "Press Start 2P",      familia: "Press Start 2P",     categoria: "tech",     preview: "REBEL"   },
  { id: "sharetech",  nombre: "Share Tech Mono",     familia: "Share Tech Mono",    categoria: "tech",     preview: "REBEL_"  },
  { id: "rajdhani",   nombre: "Rajdhani",            familia: "Rajdhani",           categoria: "tech",     preview: "REBEL"   },
];

export const CATEGORIAS = [
  { id: "todas",    label: "TODAS"    },
  { id: "display",  label: "DISPLAY"  },
  { id: "bold",     label: "BOLD"     },
  { id: "elegante", label: "ELEGANTE" },
  { id: "script",   label: "SCRIPT"   },
  { id: "street",   label: "STREET"   },
  { id: "tech",     label: "TECH"     },
];

// Fonts that need a larger pixel size on the canvas to read well.
export const SCRIPT_FAMILIES = new Set([
  "Pacifico",
  "Dancing Script",
  "Great Vibes",
  "Sacramento",
  "Permanent Marker",
]);
// Pixel-style fonts that need a smaller size.
export const PIXEL_FAMILIES = new Set([
  "Press Start 2P",
  "Share Tech Mono",
]);

// Returns the recommended base canvas pixel size for a given font family.
export const getFontPxFor = (familia) => {
  if (SCRIPT_FAMILIES.has(familia)) return 52;
  if (PIXEL_FAMILIES.has(familia)) return 28;
  return 42;
};
